var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DialogActions, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
var TransferCommunityOwnershipRequestDialog = function (_a) {
    var targetUserId = _a.targetUserId, handleUpdateCommunityUser = _a.handleUpdateCommunityUser, handleClose = _a.handleClose;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    return (_jsxs("div", __assign({ className: "flex flex-col p-0 pb-20 max-w-320" }, { children: [_jsx("div", __assign({ className: "tw-dialog-header" }, { children: t('Передать права владельца') }), void 0), _jsx(Typography, __assign({ className: "text-16 text-center pb-20 dark:text-white" }, { children: t('transferCommunityOwnershipRequest') }), void 0), _jsxs(DialogActions, __assign({ className: "flex justify-between p-0" }, { children: [_jsx(Button, __assign({ variant: "text", type: "reset", onClick: handleClose }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ onClick: function () {
                            handleUpdateCommunityUser({ userId: targetUserId, isOwner: true, isAdmin: false });
                            handleClose();
                        }, type: "submit" }, { children: t('Да') }), void 0)] }), void 0)] }), void 0));
};
export default TransferCommunityOwnershipRequestDialog;
